import Archive from "./Archive";
import CodeHighlighter from "./CodeHighlighter";
import FormContact from "./FormContact";
import Header from "./Header";
import Hello from "./Hello";
import Scroller from "./Scroller";

const app = {
  init: () => {
    Hello.init();

    Header.init();
    Scroller.init();
    Archive.init();

    FormContact.init();
    CodeHighlighter.init();
  },
};

document.readyState === "loading"
  ? document.addEventListener("DOMContentLoaded", app.init)
  : app.init();
